import { render, staticRenderFns } from "./CategoryRegister.vue?vue&type=template&id=cdd787f0"
import script from "./CategoryRegister.vue?vue&type=script&lang=js"
export * from "./CategoryRegister.vue?vue&type=script&lang=js"
import style0 from "./CategoryRegister.vue?vue&type=style&index=0&id=cdd787f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports